import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorWithdraw = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M11.75 2.25c.204 0 .4.083.541.231l5.75 6A.75.75 0 1 1 16.96 9.52L12.5 4.867V15a.75.75 0 0 1-1.5 0V4.867L6.541 9.519A.75.75 0 1 1 5.46 8.48l5.75-6a.75.75 0 0 1 .541-.231Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M3 12.75a.75.75 0 0 1 .75.75v5c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-5a.75.75 0 0 1 1.5 0v5A2.75 2.75 0 0 1 19 21.25H5a2.75 2.75 0 0 1-2.75-2.75v-5a.75.75 0 0 1 .75-.75Z"
    />
  </svg>
);
export default SvgTwoColorWithdraw;
